var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblesTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 421,
    viewBox: "0 0 382 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.824 13.2242C196.889 13.2242 192.889 17.2582 192.889 22.2343C192.889 27.2104 196.889 31.2444 201.824 31.2444C206.759 31.2444 210.759 27.2104 210.759 22.2343C210.759 17.2582 206.759 13.2242 201.824 13.2242Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8256 210.072C57.2533 215.498 55.4864 226.096 60.8678 233.732C66.3501 241.51 76.8605 243.292 84.4328 237.866C92.1465 232.337 93.9235 221.739 88.431 213.961C83.0496 206.335 72.5392 204.544 64.8256 210.072Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.021 184.192C114.601 184.192 107.776 191.075 107.776 199.565C107.776 208.055 114.601 214.938 123.021 214.938C131.441 214.938 138.267 208.055 138.267 199.565C138.267 191.075 131.441 184.192 123.021 184.192Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.728 141.89C196.867 137.482 198.27 129.103 193.909 122.913C189.537 116.723 181.126 115.165 174.988 119.564C168.849 123.972 167.405 132.595 171.777 138.785C176.139 144.985 184.59 146.299 190.728 141.89Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.798 174.632C152.271 180.975 161.065 182.471 167.203 178.063C173.483 173.553 174.826 164.787 170.364 158.455C165.992 152.265 157.339 150.666 151.049 155.166C144.921 159.575 143.436 168.442 147.798 174.632Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.442 44.6832C192.586 48.1651 191.576 54.9659 195.029 59.8629C198.381 64.6174 205.085 65.8798 209.941 62.398C214.798 58.9161 215.807 52.1153 212.455 47.3608C209.002 42.4638 202.298 41.2013 197.442 44.6832Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.215 99.0896C191.182 104.699 199.098 106.176 204.671 102.185C210.386 98.0817 211.597 90.0592 207.64 84.4393C203.571 78.6769 195.756 77.3433 190.042 81.4462C184.468 85.4371 183.146 93.3273 187.215 99.0896Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32564 219.52C1.89468 224.844 0.0268326 235.3 5.40823 242.936C10.6887 250.419 21.1991 252.21 28.63 246.886C36.2023 241.459 37.8278 230.963 32.5474 223.47C27.166 215.834 16.898 214.093 9.32564 219.52Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M346.687 47.381C353.563 55.9024 366.042 57.1343 374.392 50.0687C382.843 43.1355 384.064 30.552 377.057 22.1324C370.182 13.611 357.702 12.3791 349.353 19.4446C340.902 26.3778 339.67 38.9614 346.687 47.381Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8131 369.596C59.2018 356.392 39.8873 354.62 26.6509 365.422C13.6467 376.265 11.9 395.741 22.7537 408.986C33.5064 422.099 52.6795 423.962 65.8149 413.018C78.8191 402.185 80.6668 382.852 69.8131 369.596Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M314.682 231.92C305.696 221.016 289.501 219.398 278.688 228.459C267.875 237.52 266.31 253.605 275.255 264.753C284.241 275.657 300.335 277.123 311.148 268.072C322.062 259.154 323.668 242.824 314.682 231.92Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.559 87.7889C330.644 95.9846 329.332 110.594 337.459 120.592C345.587 130.589 360.176 132.055 369.99 123.717C379.915 115.522 381.369 100.81 373.09 90.9145C364.962 80.9067 350.474 79.5831 340.559 87.7889Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.353 344.917C160.398 331.519 140.74 329.575 127.453 340.621C114.167 351.667 112.238 371.489 123.193 384.888C134.147 398.286 153.946 400.128 167.233 389.082C180.51 378.036 182.307 358.315 171.353 344.917Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M254.598 295.835C244.663 283.883 226.994 282.02 215 292.14C203.045 302.015 201.44 319.872 211.234 331.927C221.179 343.889 238.736 345.61 250.832 335.622C262.786 325.747 264.391 307.9 254.598 295.835Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M317.569 159.788C306.897 168.747 305.474 184.731 314.359 195.493C323.102 206.356 338.944 207.791 349.626 198.832C360.409 190.015 361.822 174.031 352.937 163.27C344.194 152.407 328.352 150.982 317.569 159.788Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0652 289.269C41.2203 279.068 26.8228 277.245 16.8375 285.054C6.86219 292.863 5.05494 307.381 12.8999 317.592C20.6438 327.651 35.0413 329.473 45.0267 321.664C55.012 313.846 56.8092 299.328 49.0652 289.269Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M283.948 57.2463C290.319 52.2475 291.389 42.7996 286.432 36.3755C281.515 29.707 272.146 28.6176 265.775 33.6266C259.263 38.7273 258.081 48.0326 263.15 54.5992C268.117 61.0132 277.446 62.3469 283.948 57.2463Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.424 273.112C117.478 262.758 102.839 260.905 92.7118 268.816C82.4438 276.828 80.6062 291.6 88.5521 301.944C96.5384 312.044 111.188 313.907 121.305 305.996C131.421 298.076 133.269 283.313 125.424 273.112Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M262.039 167.964C270.156 161.489 271.651 149.577 265.371 141.279C258.949 133.094 247.136 131.587 238.908 137.92C230.79 144.395 229.296 156.306 235.576 164.604C241.997 172.789 253.81 174.296 262.039 167.964Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.637 84.582C250.226 90.548 248.903 101.472 254.678 109.047C260.555 116.764 271.388 118.098 279.041 112.182C286.452 106.216 287.775 95.2923 281.999 87.7177C276.123 79.9904 265.29 78.6567 257.637 84.582Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.326 188.478C199.956 194.912 198.432 207.079 204.954 215.407C211.476 223.745 223.4 225.384 231.659 218.807C240.17 212.271 241.564 200.217 235.173 191.777C228.65 183.449 216.595 181.901 208.326 188.478Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.656 10.1902C264.906 15.6064 272.66 16.543 278.032 12.2569C283.504 8.11325 284.433 0.294363 280.182 -5.12187C276.073 -10.6399 268.319 -11.5766 262.847 -7.43294C257.485 -3.14679 256.546 4.67212 260.656 10.1902Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M184.983 267.899C194.211 260.854 195.807 247.568 188.81 238.262C181.672 229.069 168.395 227.308 159.278 234.506C150.151 241.693 148.555 254.99 155.552 264.285C162.69 273.488 175.866 275.097 184.983 267.899Z",
    fill: "#27AAE1",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesTop);
export default __webpack_public_path__ + "static/media/bubbles-top.8a10340f23fbe1e5072f44915cc25d50.svg";
export { ForwardRef as ReactComponent };